<template>
<div class="chapter">
<div class="inner_page">
<section title="Resources by John Ortberg">
<h1 class="resource_h"><span class="right_1" epub:type="pagebreak" id="page_2" title="2">Resources by John Ortberg</span></h1>
<p class="center"><i>Everybody’s Normal Till You Get to Know Them</i></p>
<p class="center1">(book, ebook, audio)</p>
<p class="center"><i>God Is Closer Than You Think</i></p>
<p class="center1">(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)</p>
<p class="center"><i>If You Want to Walk on Water, You’ve Got to Get Out of the Boat</i></p>
<p class="center1">(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)</p>
<p class="center"><i>Know Doubt</i></p>
<p class="center1">(book, ebook, previously titled Faith and Doubt)</p>
<p class="center"><i>The Life You’ve Always Wanted</i></p>
<p class="center1">(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)</p>
<p class="center"><i>Love Beyond Reason</i></p>
<p class="center"><i>The Me I Want to Be</i></p>
<p class="center1">(book, ebook, audio, curriculum with Scott Rubin)</p>
<p class="center"><i>Soul Keeping</i></p>
<p class="center1">(book, ebook, curriculum with Christine M. Anderson)</p>
<p class="center"><i>When the Game Is Over, It All Goes Back in the Box</i></p>
<p class="center1">(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)</p>
<p class="center"><i>Who Is This Man?</i></p>
<p class="center1">(book, ebook, audio, curriculum with Christine M. Anderson)</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310296065_Resources.vue?198253b2